/*
 * Application Insights JavaScript SDK - Web, 3.3.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
export { AppInsightsSku as ApplicationInsights } from "./AISku";
export { ApplicationInsightsContainer } from "./ApplicationInsightsContainer";
// Re-exports
export { AppInsightsCore, LoggingSeverity, PerfEvent, PerfManager, doPerf, NotificationManager, BaseTelemetryPlugin } from "@microsoft/applicationinsights-core-js";
export { SeverityLevel, Event, Exception, Metric, PageView, PageViewPerformance, RemoteDependencyData, Trace, DistributedTracingModes, EventPersistence } from "@microsoft/applicationinsights-common";
export { Sender } from "@microsoft/applicationinsights-channel-js";
export { ApplicationInsights as ApplicationAnalytics } from "@microsoft/applicationinsights-analytics-js";
export { PropertiesPlugin } from "@microsoft/applicationinsights-properties-js";
export { AjaxPlugin as DependenciesPlugin } from "@microsoft/applicationinsights-dependencies-js";
export { CfgSyncPlugin } from "@microsoft/applicationinsights-cfgsync-js";
//# sourceMappingURL=applicationinsights-web.js.map